/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.querySelectorAll('[data-toggle="collapse"]').forEach((item) => {
  item.addEventListener('click', function(event){
    event.preventDefault();
    event.stopPropagation();
    var elementId = event.currentTarget.getAttribute('aria-controls');
    event.currentTarget.setAttribute('aria-expanded', event.currentTarget.getAttribute('aria-expanded') == 'false');
    document.querySelector(`#${elementId}`).classList.toggle('show');
  });
});

class TabItems extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[data-tab]');
    this.tabSwitchers = this.querySelectorAll('[data-tab-switcher]');

    this.tabSwitchers.forEach((tabSwitcher) => {
      tabSwitcher.addEventListener('click', this.switchTab.bind(this));
    })
  }

  switchTab(event) {
    const tabSwitcher = event.target;
    if (tabSwitcher.getAttribute('aria-active') == 'true') {
      return;
    }
    this.tabSwitchers.forEach((tabSwitcher) => {
      tabSwitcher.setAttribute('aria-active', false);
    })

    tabSwitcher.setAttribute('aria-active', true);
    const tabIndex = tabSwitcher.dataset.switchTo;

    this.tabs.forEach((tab) => {
      tab.setAttribute('aria-hidden', tab.dataset.tabIndex != tabIndex);
    });
  }
}

customElements.define('tab-items', TabItems);

class FindYourFitForm extends HTMLElement {
  constructor() {
    super();

    this.baseCollectionUrl = this.dataset.collectionBaseUrl;
    this.insideCollection = this.dataset.insideCollection == 'true';
    this.form = this.querySelector('form');
    this.bandSizeInput = this.form.querySelector('[name="bandSize"]');
    this.bustSizeInput = this.form.querySelector('[name="bustSize"]');
    this.resultContainer = this.form.querySelector('[data-result-container]');
    this.resultElement = this.querySelector('[data-result]');
    this.collectionLinkElement = this.querySelector('[data-collection-link]');

    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    if (this.insideCollection) {
      this.collectionLinkElement.addEventListener('click', this.updateCollectionFilters.bind(this));
    }
  }

  updateCollectionFilters(event) {
    event.preventDefault();
    const url = event.target.getAttribute('href').split('?')[1];
    const urlParams = new URLSearchParams(url);
    const entries = urlParams.entries();
    

    if (document.getElementById('collection-filters-drawer-form')) {
      for(const entry of entries) {
        const key = entry[0];
        const value = entry[1];
        const inputs = document.querySelectorAll(`[name="${key}"]`);
        const selectedInput = document.querySelector(`[name="${key}"][value="${value}"]`);
        inputs.forEach((input) => {
          input.removeAttribute('checked');
        });
        selectedInput.setAttribute('checked', 'checked');
      }
      document.dispatchEvent(new CustomEvent('collection:filters:changed'));
      document.querySelector('[data-action="close-drawer"][data-drawer-id="find-your-fit-drawer"]').click();
    }
  }
  
  onFormSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    this.resetForm();
    const bustSizeError = this.validateBustSize();
    if (bustSizeError.hasError) {
      const errorDiv = document.createElement("div");
      errorDiv.classList.add('FindYourFitForm--inputError');
      errorDiv.setAttribute('data-error', 'data-error');
      errorDiv.innerHTML = bustSizeError.message;
      this.bustSizeInput.insertAdjacentElement("afterend", errorDiv);
      return;
    }
    
    this.calculateResultSize();
  }

  resetForm() {
    this.resultContainer.setAttribute('hidden', 'hidden');
    this.resultElement.innerHTML = '';
    this.collectionLinkElement.setAttribute('hidden', 'hidden');
    this.collectionLinkElement.setAttribute('href', '#');
    if (this.querySelector('[data-error]')) {
      this.querySelectorAll('[data-error]').forEach((error) => error.remove());
    } 
  }

  validateBustSize() {
    const bustSize = parseInt(this.bustSizeInput.value);
    const bandSize = parseInt(this.bandSizeInput.value);
    const isBandSizeEven = bandSize % 2 == 0;
    const additionalCoefficient = isBandSizeEven ? 0 : 1;
    let hasError = false;
    let message = '';

    if (bandSize > 37) {
      if (bustSize < (bandSize + additionalCoefficient) || bustSize > (bandSize + additionalCoefficient + 7)) {
        hasError = true;
        message = `Please enter a number between ${bandSize + additionalCoefficient} and ${bandSize + additionalCoefficient + 7} inches`;
      }
    } else {
      if (bustSize < (bandSize + additionalCoefficient + 2) || bustSize > (bandSize + additionalCoefficient + 9)) {
        hasError = true;
        message = `Please enter a number between ${bandSize + additionalCoefficient + 2} and ${bandSize + additionalCoefficient + 9} inches`;
      }
    }
    
    return {
      hasError,
      message,
    }
  }

  calculateResultSize() {
    const bustSize = parseInt(this.bustSizeInput.value);
    const bandSize = parseInt(this.bandSizeInput.value);
    const isBandSizeEven = bandSize % 2 == 0;

    let bandSizeResult = bandSize;
    if (bandSize < 38) {
      bandSizeResult += isBandSizeEven ? 2 : 3;
    } else {
      bandSizeResult += isBandSizeEven ? 0 : 1;
    }

    const bustSizeResult = bustSize - bandSizeResult;
    
    const bustSizeResultLetters = ["A","B","C","D","E","F","G","H"];
    const bustSizeResultLetter = bustSizeResultLetters[bustSizeResult] ? bustSizeResultLetters[bustSizeResult] : '';


    this.resultContainer.removeAttribute('hidden');
    this.resultElement.innerHTML = `${bandSizeResult} ${bustSizeResultLetter}`;

    this.collectionLinkElement.removeAttribute('hidden');
    this.collectionLinkElement.setAttribute('href', `${this.baseCollectionUrl}?filter.v.option.size=${encodeURIComponent(bandSizeResult)}&filter.v.option.dimension=${encodeURIComponent(bustSizeResultLetter)}`);
    this.collectionLinkElement.scrollIntoView({ behavior: "smooth", block: "end"});
  }
}

customElements.define('find-your-fit-form', FindYourFitForm);